import React, {FC} from "react";

export interface SectionVisionaries {
    className?: string;
    rightImg?: string;
}

const SectionVisionaries: FC<SectionVisionaries> = ({
                                                        className = "",
                                                    }) => {
    return (
        <div
            className={`text-center justify-center SectionVisionaries relative flex flex-col lg:flex-row items-center  ${className}`}
            data-id="SectionVisionaries"
        >
            <div className="text-center justify-center flex-shrink-0 mb-14 lg:mb-0 lg:mr-10 lg:w-2/5">
                <h2 className="font-semibold text-3xl sm:text-4xl mt-3">
                    Meet Our Visionaries
                </h2>
                <span className="justify-center block mt-8 text-neutral-500 dark:text-neutral-400">
                                A collective of individuals currently studying at LBU, We’re impartial and independent, and every day we create distinctive, world-class technologies for the CryptoVerse community.
        </span>

            </div>
        </div>
    );
};

export default SectionVisionaries;

